// TODO: Change 'light' with 'legacy' in the future
const extraThemes = ['forest-green', 'bright-green'];
const screenModes = ['light', 'dark'];
const DEFAULT_BASE_THEME = 'personal';
const DEFAULT_SCREEN_MODE = 'light';

export { DEFAULT_BASE_THEME, DEFAULT_SCREEN_MODE, extraThemes, screenModes };
//# sourceMappingURL=const.mjs.map
